<script lang="ts">
  const {
    message,
    retryLabel = "Retry",
    onRetry,
  }: {
    message: string;
    retryLabel?: string;
    onRetry?: (() => void) | undefined;
  } = $props();
</script>

<section class="overlay error-overlay" role="alert">
  <div class="dialog">
    <p>{message}</p>
    {#if onRetry}
      <button type="button" onclick={onRetry}>{retryLabel}</button>
    {/if}
  </div>
</section>
